//master controller
import { ModalController } from './ModalController.js';
//generic controller
import { AlertModalController } from './Controller/AlertModalController.js';
import { LoadingModalController } from './Controller/LoadingModalController.js';
//campaign controller
import { CampaignModalController } from './Controller/CampaignModalController.js';
import { AddToCartModalController } from './Controller/AddToCartModalController.js';

/**
 * Master ontroller
 * @method getModalController
 * Generic controller
 * @method getAlertModal
 * @method getLoadingModal
 * Campaign Controller
 * @method getCampaignModal
 * @method getAddToCartModal
 */
export default function ModalFactory() {
    this.modalController = new ModalController();

    // generic
    this.alertModal = null;
    this.loadingModal = null;
    this.campaignModal = null;
    this.addToCartModal = null;

    //#region generic
    this.getModalController = function() {
        return this.modalController;
    };
    this.getAlertModal = function() {
        this.alertModal = new AlertModalController();
        this.modalController.setAlertModal(this.alertModal);
        return this.alertModal;
    };
    this.getLoadingModal = function() {
        this.loadingModal = new LoadingModalController();
        this.modalController.setLoadingModal(this.loadingModal);
        return this.loadingModal;
    };
    //#endregion generic
    this.getCampaignModal = function() {
        this.campaignModal = new CampaignModalController();

        if (this.alertModal) {
            this.campaignModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.campaignModal.setLoadingModal(this.loadingModal);
        }
        if (this.addToCartModal) {
            this.campaignModal.setAddToCartModal(this.addToCartModal);
        }

        this.modalController.setCampaignModal(this.campaignModal);
        return this.campaignModal;
    };
    this.getAddToCartModal = function() {
        this.addToCartModal = new AddToCartModalController();
        this.modalController.setAddToCartModal(this.addToCartModal);
        return this.addToCartModal;
    };

}
